import { render, staticRenderFns } from "./CardContratoContato.vue?vue&type=template&id=acc9cf6e&lang=pug"
import script from "./CardContratoContato.vue?vue&type=script&lang=js"
export * from "./CardContratoContato.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports